var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloads(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50.38 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.4,22.67a2.49,2.49,0,0,0-1.77.76l-7.05,7.05v-28a2.52,2.52,0,0,0-5,0v28l-7-7a2.45,2.45,0,0,0-1.76-.76,2.49,2.49,0,0,0-1.77.76A2.44,2.44,0,0,0,12,27L23.3,38.29h0c.13.12.25.25.38.25h.25c.13,0,.13.12.25.12h1.64a.49.49,0,0,0,.38-.12h0c.12,0,.25-.13.37-.25s.26-.13.38-.25h0L38.29,26.7a2.45,2.45,0,0,0,0-3.53A5.31,5.31,0,0,0,36.4,22.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.86,36.15a2.52,2.52,0,0,0-2.52,2.51V45H5v-6.3a2.52,2.52,0,0,0-5,0v8.82A2.52,2.52,0,0,0,2.52,50H47.86a2.53,2.53,0,0,0,2.52-2.52V38.66A2.53,2.53,0,0,0,47.86,36.15Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloads);
export default __webpack_public_path__ + "static/media/Downloads.6d18fe18.svg";
export { ForwardRef as ReactComponent };